<template>
  <!-- Begin Page Content -->
  <v-container class="pa-0">
    <AlarmCard />
    <GarageGateCard />
    <TempContainer />
    <SensorCard />
  </v-container>
</template>

<script>
import AlarmCard from "../components/Alarm/AlarmCard.vue";
import TempContainer from "../components/Temp/TempContainer.vue";
import SensorCard from "../components/SensorCard/SensorCard.vue";
import GarageGateCard from "../components/GarageGateCard/GarageGateCard.vue";

export default {
  components: {
    AlarmCard,
    SensorCard,
    GarageGateCard,
    TempContainer,
  },
  data() {
    return {
      data: [
        { x: "2021-11-06 23:39:30", y: 21.5 },
        { x: "2021-11-06 23:39:30", y: 23.0 },
        { x: "2024-12-09T12:00:00Z", y: 18 },
        { x: "2024-12-09T13:00:00Z", y: 16.5 },
        { x: "2024-12-09T14:00:00Z", y: 15.0 },
        { x: "2024-12-09T15:00:00Z", y: 16 },
        { x: "2024-12-09T16:00:00Z", y: 22.5 },
        { x: "2024-12-09T17:00:00Z", y: 23.0 },
        { x: "2024-12-09T18:00:00Z", y: 18 },
        { x: "2024-12-09T19:00:00Z", y: 16.5 },
        { x: "2024-12-09T20:00:00Z", y: 15.0 },
        { x: "2024-12-09T21:00:00Z", y: 21.8 },
      ],
    };
  },
};
</script>

<style>
.offcanvas {
  transition: 0.5s;
}
</style>
